import classNames from 'classnames';
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import Flickity, { FlickityOptions } from 'react-flickity-component';

import ArrowRight from '../../images/icon-arrow-right.svg';

export enum GalleryLayout {
  A = 1,
  B = 2,
}

type Slide = {
  description?: string;
  image: string;
  link?: string;
  title?: string;
};

export type GalleryProps = {
  data: Slide[];
  layout?: GalleryLayout;
  options?: FlickityOptions;
  title?: string;
  marginLess?: boolean;
};

export const Gallery = ({
  title,
  data = [],
  options,
  layout = GalleryLayout.A,
  marginLess = false,
}: GalleryProps) => {
  const { t } = useTranslation();

  return (
    <section className={classNames('gallery', marginLess && 'is-marginless')}>
      {layout === GalleryLayout.A && !!title && <h4>{title}</h4>}

      {/* @ts-ignore */}
      <Flickity
        elementType={'div'}
        options={{
          prevNextButtons: false,
          ...options,
        }}
        disableImagesLoaded={false}
        reloadOnUpdate
        static
      >
        {data.map((slide, index) => (
          <div className={classNames('slide', `layout${layout}`)} key={index}>
            {slide.link ? (
              <Link
                to={slide.link}
                className='image'
                style={{ backgroundImage: `url(${slide.image})` }}
              />
            ) : (
              <div
                className='image'
                style={{ backgroundImage: `url(${slide.image})` }}
              />
            )}

            {slide.link && slide.title && (
              <Link to={slide.link}>
                <div className='title'>{slide.title}</div>
              </Link>
            )}

            {layout === GalleryLayout.A && (
              <>
                {slide.description && (
                  <div
                    className='description'
                    dangerouslySetInnerHTML={{ __html: slide.description }}
                  />
                )}
                {slide.link && (
                  <div className='link'>
                    <Link to={slide.link}>
                      {t('SHOW_MORE')} <ArrowRight />
                    </Link>
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </Flickity>

      {layout === GalleryLayout.B && !!title && <h4>{title}</h4>}
    </section>
  );
};
